import  { Navigate } from 'react-router-dom'

const Redireccion = () => {

    return (
        <Navigate to='/'></Navigate>
    )
}

export default Redireccion
